import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { CompanyDto } from './company-dto.model';
import { ProjectDto } from './project-dto.model';
import { ThumbApplicationFromType } from '../service-proxies';


export class DailyTravellingDetailsDto implements IDailyTravellingDetailsDto {
    employee!: EmployeeSummaryDto;
    eventDate!: Date | undefined;
    empLegalName!: string | undefined;
    calcType!: string | undefined;
    company!: CompanyDto;
    project!: ProjectDto;
    thumbApplicationFromType!: ThumbApplicationFromType;
    thumbApplicationFromTypeName!: string | undefined;
    thumbRemark!: string | undefined;
    requestTypeCode!: string | undefined;
    siteKM!: number;
    amount!: number;

    constructor(data?: IDailyTravellingDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.empLegalName = _data["empLegalName"];
            this.calcType = _data["calcType"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.thumbApplicationFromType = _data["thumbApplicationFromType"];
            this.thumbApplicationFromTypeName = _data["thumbApplicationFromTypeName"];
            this.thumbRemark = _data["thumbRemark"];
            this.requestTypeCode = _data["requestTypeCode"];
            this.siteKM = _data["siteKM"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): DailyTravellingDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyTravellingDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["empLegalName"] = this.empLegalName;
        data["calcType"] = this.calcType;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["thumbApplicationFromType"] = this.thumbApplicationFromType;
        data["thumbApplicationFromTypeName"] = this.thumbApplicationFromTypeName;
        data["thumbRemark"] = this.thumbRemark;
        data["requestTypeCode"] = this.requestTypeCode;
        data["siteKM"] = this.siteKM;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IDailyTravellingDetailsDto {
    employee: EmployeeSummaryDto;
    eventDate: Date | undefined;
    empLegalName: string | undefined;
    calcType: string | undefined;
    company: CompanyDto;
    project: ProjectDto;
    thumbApplicationFromType: ThumbApplicationFromType;
    thumbApplicationFromTypeName: string | undefined;
    thumbRemark: string | undefined;
    requestTypeCode: string | undefined;
    siteKM: number;
    amount: number;
}

